export default function () {
    async function put(idEvent) {
        let error = null;
        try {
            await useApi('events').put('events/' + idEvent + '/interest');
        } catch (e) {
            error = useApiError(e);
        }
        return {error};
    }

    async function remove(idEvent) {
        let error = null;
        try {
            await useApi('events').delete('events/' + idEvent + '/interest');
        } catch (e) {
            error = useApiError(e);
        }
        return {error};
    }

    return {put, remove};
}
